import { render, staticRenderFns } from "./AreYouSurePopup.vue?vue&type=template&id=5c5f84ff&scoped=true&"
import script from "./AreYouSurePopup.vue?vue&type=script&lang=js&"
export * from "./AreYouSurePopup.vue?vue&type=script&lang=js&"
import style0 from "./AreYouSurePopup.vue?vue&type=style&index=0&id=5c5f84ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f84ff",
  null
  
)

export default component.exports